import React from 'react';
import PropTypes from 'prop-types';
import ThrowInDev from 'Helpers/ThrowInDev';
import { StandardImpact } from './standard';
import { QuoteImpact } from './quote';

const layouts = {
  standard: StandardImpact,
  quote: QuoteImpact,
};

export function ImpactPicker({ resource }) {
  const Layout = layouts[resource.attr('impactType')];
  if (!Layout) {
    return <ThrowInDev err={`Unknown impact type ${resource.attr('impactType')}`} />;
  }
  return <Layout resource={resource} />;
}

ImpactPicker.defaultProps = {
};

ImpactPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};
